// extracted by mini-css-extract-plugin
export default {"ImageBlock":"ImageBlockBgvu_","imageBlock":"ImageBlockBgvu_"};